import React, { useEffect, useState } from "react";

import ButtonGroupCustom from "../components/button_group";
import CardsTable from "../components/cards_table/index";
import CardReport from "../components/card_info/card_report";

import { report_data } from "../constants/table_data";

const Report = () => {
  const [selectedTab, setSelectedTab] = useState(0)
  const [reportData, setReportData] = useState([])

  const getData = async() => {
    setReportData(report_data)
  } 

  useEffect(() => {
    getData()
  }, [])

  return (
    <>
      <div className="border-bottom-container bg-light px-3 px-sm-4 px-xxl-5">
        <div className="py-3 buttom-group-container d-inline-block">
          <ButtonGroupCustom 
            active={selectedTab}
            setActive={setSelectedTab}
            items={['Дэд карт', 'Толгой карт']}
          />
        </div>
      </div>
      <div className="page-content px-3 px-sm-4 px-xxl-5">
        <div className="ms-0 py-3 mb-5">
          <CardReport />
          <CardsTable 
            flag="report"
            tableData={reportData}
          />
        </div>
      </div>
    </>
  );
};

export default Report;
